Ext.define('SA.TableCell', {
    constructor({el}) {
        this.el = el;
        this.el.className = 'sa-table-cell';

        this.el.addEventListener('mousedown', this.onMouseDown.bind(this));
    },

    getBox() {
        return Ext.util.Region.getRegion(this.el);
    },

    getClickParams() {
        return {};
    },

    getState() {
        return this.el.state;
    },

    onMouseDown({clientX: x, clientY: y}) {
        if (!this.permitMouesEvent()) {
            return;
        }

        var cellXy = Ext.fly(this.el).getXY(),
            offset = [x - cellXy[0], y - cellXy[1]];

        new SA.MouseActivity({
            xy: [x, y],
            eventPrefix: 'cell',
            eventTarget: this.el.closest('table'),
            clickParams: this.getClickParams(),
            dragStartParams: this.getDragStartParams({offset})
        });
    },

    permitMouesEvent() {
        return false;
    },

    setState(state) {
        if (Ext.Object.equals(state, this.el.state)) {
            return;
        }

        this.el.state = state;

        this.onStateChange(state);
    }
});